import { ApolloCache } from '@apollo/client';

export interface CachedData {
  ROOT_QUERY: {
    [key: string]: unknown;
  };
  [id: string]: unknown;
}

export function isCachedData(
  cache: ApolloCache<any>,
): cache is ApolloCache<CachedData> {
  return 'ROOT_QUERY' in cache.extract();
}
